import { Controller } from "@hotwired/stimulus"

const THEME_KEY = "color-theme"

export default class extends Controller {
  connect() {
    this.applyTheme = this.applyTheme.bind(this)
    this.applyTheme()
    document.addEventListener("turbo:load", this.applyTheme)
  }

  disconnect() {
    document.removeEventListener("turbo:load", this.applyTheme)
  }

  applyTheme() {
    const isMarketing = this.element.classList.contains("marketing")
    const preferredTheme = localStorage.getItem(THEME_KEY)
    const useDarkTheme = isMarketing ? false : preferredTheme ? preferredTheme === "dark" : true

    document.documentElement.classList.toggle("dark", useDarkTheme)
  }
}
